<template>
  <el-row>

    <el-row style="background-color: #13305D;min-height: 4rem" >
      <el-menu
          :default-active="activeIndex2"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          background-color="#13305D"
          text-color="#fff"
          active-text-color="#ffd04b"
          float="right"

      >
        <el-menu-item class="emi" index="1" style="color:#ffd04b;font-size: 0.95rem;padding-right:8px;padding-left: 10px " @click="mainClick"> RNAPhaSep</el-menu-item>
<!--        <el-menu-item index="2"  ><el-input @keyup.enter.native="searchClick" v-model="input" placeholder="quick search"></el-input></el-menu-item>-->
        <el-menu-item class="emi"  index="9" style="float: right;font-size: 0.9rem;padding-left: 8px;margin-right: 0" @click="contactClick"><img src="../../assets/img/phone.png" height=25 width=25>Contact</el-menu-item>
        <el-menu-item class="emi"  index="8" style="float: right;padding: 0 8px;font-size: 0.9rem" @click="helpClick"><img src="../../assets/img/help.png" height=25 width=25>Help</el-menu-item>

        <el-menu-item class="emi"  index="7" style="float: right;padding: 0 8px;font-size: 0.9rem" @click="statisticsClick"><img src="../../assets/img/text.png" height=25 width=25>Statistics</el-menu-item>

        <el-menu-item class="emi"  index="6" style="float: right;padding: 0 8px;font-size: 0.9rem" @click="downloadClick"><img src="../../assets/img/download.png" height=25 width=25>Download</el-menu-item>
        <el-menu-item class="emi"  index="5" style="float: right;padding: 0 8px;font-size: 0.9rem" @click="submitClick"><img src="../../assets/img/up.png" height=25 width=25>Submit</el-menu-item>

        <el-menu-item class="emi"  index="3" style="float: right;padding: 0 8px;font-size: 0.9rem" @click="dataClick"><img src="../../assets/img/browse.png" height=25 width=25>Browse</el-menu-item>
        <el-menu-item class="emi"  index="4" style="float: right;padding: 0 8px;font-size: 0.9rem" @click="searchdetailClick"><img src="../../assets/img/search.png" height=25 width=25>Search/Blast</el-menu-item>
        <el-menu-item class="emi" index="2" style="float: right;padding: 0 8px;font-size: 0.9rem" @click="mainClick"><img src="../../assets/img/wxb.png" height=25 width=25> Home</el-menu-item>


      </el-menu>

    </el-row>

    <el-row class="back1" style="height:6.5rem"></el-row>

  </el-row>
</template>

<script>
export default {
  name:'navbar',
  data() {
    return {
      activeIndex2: '1',
    };
  },
  methods: {
    mainClick(){
      this.$router.push('/Home')
    }
    ,
    homeClick(){
      this.$router.push('/Home')
    }

    ,
    helpClick(){
      this.$router.push('/Help')
    }
    ,
    contactClick(){
      this.$router.push('/Contact')
    }
    ,
    dataClick(){
      if('/Browse'==this.$route.path){
        console.log(this.$route.path)
        this.$router.go(0)
      }else {
        this.$router.push('/Browse')
      }

    },
    downloadClick(){
      this.$router.push('/Download')
    },
    statisticsClick(){
      this.$router.push('/Statistics')
    }
    ,
    searchdetailClick(){
      if('/Search'==this.$route.path){
        console.log(this.$route.path)
        this.$router.go(0)
      }else {
        this.$router.push('/Search')
      }
    },
    submitClick(){
      if('/Submit'==this.$route.path){
        console.log(this.$route.path)
        this.$router.go(0)
      }else {
        this.$router.push('/Submit')
      }
    }
  }
}
</script>

<style scoped>
.el-menu.el-menu--horizontal {
  margin-top: 0px;
  opacity:0.85;
  width: 100%;

}

.back1{
  background: url("../../assets/img/bc6.png"),repeat-x,repeat-y;
  background-size:100% 100%;
}


</style>